import { defineCustomElement, type Component } from "vue";
import { ObjectValues } from "@/src/shared/types/objectValues";

export type VueCustomElementSource = Parameters<typeof defineCustomElement>[0];
export type ComponentLoader = () => Promise<{ default: Component }>;

export const PROP_TYPE_HINT = {
  Boolean: "boolean",
  Number: "number",
  String: "string",
  Date: "date",
  Time: "time",
} as const;

export type PropTypeHint = ObjectValues<typeof PROP_TYPE_HINT>;
export type SlotDefinition = string | RegExp;

type RegistryEntryBase = {
  propTypes?: Record<string, PropTypeHint>;
  modelValueType?: PropTypeHint;
  slots?: SlotDefinition[];
  exposedMethods?: string[];
  /** Additional events to forward alongside the lazily resolved component's runtime emits (deduplicated). */
  emits?: string[];
  /** Set to `false` to forward only `emits`, for components whose payloads must not reach ancestor listeners. */
  forwardComponentEmits?: boolean;
};

export type RegistryEntry = RegistryEntryBase & {
  loadComponent: ComponentLoader;
};
